if (!customElements.get("marsh-video-community")) {
  class MarshVideoCommunity extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.items = parseInt(this.dataset.items, 10) || 3;
      this.showNavigation = this.dataset.showNavigation === "true";
      this.slideContainer = this.querySelector(".marsh-video-community__slider-wrapper");

      this.initSlider();
      this.initPlayToggles();
      this.initSoundToggles();
    }

    disconnectedCallback() {
      if (this.slider && typeof this.slider.destroy === "function") {
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }

    initSlider() {
      if (!this.slideContainer) return;
      if (typeof MinimogLibs === "undefined" || !MinimogLibs.Swiper) {
        console.warn("MarshVideoCommunity: MinimogLibs.Swiper is not available.");
        return;
      }

      const slidesCount = this.slideContainer.querySelector(".swiper-wrapper")?.childElementCount || 0;

      this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        threshold: 2,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1280: {
            slidesPerView: this.items,
            spaceBetween: 24,
          },
        },
        on: {
          init: (swiper) => this.updateNavState(swiper),
          slideChange: (swiper) => {
            this.updateNavState(swiper);
            this.pauseAll();
          },
          breakpoint: (swiper) => this.updateNavState(swiper),
        },
      });

      const prevButton = this.querySelector(".marsh-video-community__nav-prev");
      const nextButton = this.querySelector(".marsh-video-community__nav-next");

      if (this.slider && this.showNavigation) {
        prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
      }

      if (slidesCount <= this.items) {
        this.slideContainer.classList.add("marsh-video-community__slider--static");
      }
    }

    updateNavState(swiper) {
      const prevButton = this.querySelector(".marsh-video-community__nav-prev");
      const nextButton = this.querySelector(".marsh-video-community__nav-next");
      if (!prevButton || !nextButton || !swiper) return;

      prevButton.toggleAttribute("disabled", swiper.isBeginning);
      nextButton.toggleAttribute("disabled", swiper.isEnd);
    }

    pauseAll(exceptCard = null) {
      this.querySelectorAll(".marsh-video-community__card").forEach((card) => {
        if (exceptCard && card === exceptCard) return;

        const video = card.querySelector("video");
        const playButton = card.querySelector("[data-play-toggle]");
        const soundButton = card.querySelector("[data-sound-toggle]");

        if (video) {
          video.pause();
          video.muted = true;
        }

        card.classList.remove("is-playing");
        if (playButton) {
          playButton.classList.remove("is-playing");
          playButton.setAttribute("aria-pressed", "false");
          playButton.setAttribute("aria-label", "Play video");
        }
        if (soundButton) {
          soundButton.classList.remove("is-unmuted");
          soundButton.setAttribute("aria-pressed", "false");
        }
      });
    }

    initPlayToggles() {
      this.querySelectorAll("[data-play-toggle]").forEach((button) => {
        button.addEventListener("click", () => {
          const card = button.closest(".marsh-video-community__card");
          const video = card && card.querySelector("video");
          if (!video) return;

          const shouldPlay = video.paused;

          if (shouldPlay) {
            this.pauseAll(card);
            video.muted = true;
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === "function") {
              playPromise.catch(() => {});
            }
            card.classList.add("is-playing");
            button.classList.add("is-playing");
            button.setAttribute("aria-pressed", "true");
            button.setAttribute("aria-label", "Pause video");
          } else {
            video.pause();
            video.muted = true;
            card.classList.remove("is-playing");
            button.classList.remove("is-playing");
            button.setAttribute("aria-pressed", "false");
            button.setAttribute("aria-label", "Play video");

            const soundButton = card.querySelector("[data-sound-toggle]");
            if (soundButton) {
              soundButton.classList.remove("is-unmuted");
              soundButton.setAttribute("aria-pressed", "false");
            }
          }
        });
      });
    }

    initSoundToggles() {
      this.querySelectorAll("[data-sound-toggle]").forEach((button) => {
        button.addEventListener("click", () => {
          const card = button.closest(".marsh-video-community__card");
          const video = card && card.querySelector("video");
          const playButton = card && card.querySelector("[data-play-toggle]");
          if (!video) return;

          const unmute = video.muted;

          this.querySelectorAll("video").forEach((v) => {
            if (v !== video) v.muted = true;
          });
          this.querySelectorAll("[data-sound-toggle]").forEach((b) => {
            b.classList.remove("is-unmuted");
            b.setAttribute("aria-pressed", "false");
          });

          if (unmute) {
            if (video.paused) {
              this.pauseAll(card);
              const playPromise = video.play();
              if (playPromise && typeof playPromise.catch === "function") {
                playPromise.catch(() => {});
              }
              card.classList.add("is-playing");
              if (playButton) {
                playButton.classList.add("is-playing");
                playButton.setAttribute("aria-pressed", "true");
                playButton.setAttribute("aria-label", "Pause video");
              }
            }
            video.muted = false;
            button.classList.add("is-unmuted");
            button.setAttribute("aria-pressed", "true");
          } else {
            video.muted = true;
          }
        });
      });
    }
  }

  customElements.define("marsh-video-community", MarshVideoCommunity);
}
